import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { IndicationServiceV2 } from '../../../../services/indication.service';
import { EMPTY, forkJoin, of } from 'rxjs';

export const indicationSummaryResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const indicationService = inject(IndicationServiceV2);
  const id = route.paramMap.get('id') || route.parent?.paramMap.get('id');

  if (!id) {
    router.navigate(['v2', 'indications']);
    return EMPTY;
  }

  if (id === 'novo') {
    return forkJoin({
      editMode: of(false),
      indicationId: of(null),
      areaOfExpertise: indicationService.getPracticeAreas(),
    });
  }

  const indicationId = Number(id);

  if (isNaN(indicationId)) {
    router.navigate(['v2', 'indications']);
    return EMPTY;
  }

  return forkJoin({
    areaOfExpertise: indicationService.getPracticeAreas(),
    indication: indicationService.getById(indicationId),
    editMode: of(true),
  });
};
